import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'
import { integrationsClient } from '../../../utils/apollo/api'

const QUERY = gql`
  query omieProjects($integrationId: Int, $page: Int, $search: String) {
    omieProjects(integrationId: $integrationId, page: $page, limit: 999, search: $search) {
      codigo
      nome
    }
  }
`

export const useProjectSelectLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: integrationsClient })

  return (search, page = 1) => {
    return query({ search, page, ...filter })
      ?.then(pathOr([], ['data', 'omieProjects']))
      .then(data => {
        const result = data.map((item, index) => {
          return {
            id: item.codigo,
            name: item.nome
          }
        })

        return result
      })
  }
}

const ProjectSelect = ({ onChange, value, filter, ...props }) => {
  const getOptions = useProjectSelectLoader(filter)

  return <Select value={value} onChange={onChange} options={getOptions} {...props} />
}

export default ProjectSelect
